import { VoucherService, CouponService, TutorVoucherService, TutorCouponService } from "@/common/api.service";
import { FETCH_VOUCHERS, LIST_COUPONS, BUY_VOUCHERS, SEND_COUPONS, REVOKE_COUPON, VALIDATE_COUPON, FETCH_TUTOR_VOUCHERS, LIST_TUTOR_COUPONS, BUY_TUTOR_VOUCHERS, SEND_TUTOR_COUPONS, REVOKE_TUTOR_COUPON, VALIDATE_TUTOR_COUPON, RESET_STATE } from "./actions.type";
import { SET_VOUCHERS, SET_COUPONS, SET_ERROR, SET_TUTOR_VOUCHERS, SET_TUTOR_COUPONS, STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        vouchers: [],
        coupons: [],
        vouchererrors:[],
        
        tutorvouchers: [],
        tutorcoupons: [],
        tutorvouchererrors:[],
    }
}

let state = initialState()

const getters = {
    vouchers(state) {
        return state.vouchers
    },
}

const actions = {
    async [FETCH_VOUCHERS](context, slug) {
        const { data } = await VoucherService.get(slug)
        context.commit(SET_VOUCHERS, data.data)
        return data;
    },
    async [BUY_VOUCHERS](context,payload){
        return VoucherService.order(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [LIST_COUPONS](context, slug) {
        const { data } = await CouponService.get(slug)
        context.commit(SET_COUPONS, data.data)
        return data;
    },
    async [SEND_COUPONS](context,payload){
        return CouponService.send(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [REVOKE_COUPON] (context, couponid) {
        return CouponService.revoke(couponid)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [VALIDATE_COUPON](context, params) {
        return CouponService.validate(params)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },

    async [FETCH_TUTOR_VOUCHERS](context, slug) {
        const { data } = await TutorVoucherService.get(slug)
        context.commit(SET_TUTOR_VOUCHERS, data.data)
        return data;
    },
    async [BUY_TUTOR_VOUCHERS](context,payload){
        return TutorVoucherService.order(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [LIST_TUTOR_COUPONS](context, slug) {
        const { data } = await TutorCouponService.get(slug)
        context.commit(SET_TUTOR_COUPONS, data.data)
        return data;
    },
    async [SEND_TUTOR_COUPONS](context,payload){
        return TutorCouponService.send(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [REVOKE_TUTOR_COUPON] (context, couponid) {
        return TutorCouponService.revoke(couponid)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },
    async [VALIDATE_TUTOR_COUPON](context, params) {
        return TutorCouponService.validate(params)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    },

}

const mutations = {
    [SET_VOUCHERS](state, voucherdata) {
        state.vouchers = voucherdata
    },
    [SET_COUPONS](state, coupondata) {
        state.coupons = coupondata
    },

    [SET_TUTOR_VOUCHERS](state, voucherdata) {
        state.tutorvouchers = voucherdata
    },
    [SET_TUTOR_COUPONS](state, coupondata) {
        state.tutorcoupons = coupondata
    },

    [SET_ERROR](state, error) {
        state.vouchererrors = error;
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

